// Openstaande orders: every TALIS order between O50 (Nacalculatie) and O60
// (Facturabel), refreshed from TALIS every ~10 minutes, plus the staff's own
// notes on them. See docs/open-orders.md.

import { apiClient } from "@/lib/api";
import type { ProformaStatus } from "@/lib/types";

// Mirrors services/api openOrders.router.ts.
export interface OpenOrderActivity {
  talisActivityId: number;
  sequence: number | null;
  status: string | null; // O-code
  date: string | null; // YYYY-MM-DD
  invoiceText: string | null;
  revenueCents: number;
  invoicedCents: number;
}

export interface OpenOrder {
  talisOrderNumber: string;
  customerCode: string | null;
  customerName: string | null;
  projectLeadName: string | null;
  projectLeadEmail: string | null;
  talisRemarks: string | null;
  firstActivityDate: string | null;
  lastActivityDate: string | null;
  revenueCents: number;
  openRevenueCents: number;
  activities: OpenOrderActivity[];
  noteCount: number;
  latestNote: { body: string; authorName: string; createdAt: string } | null;
  proformas: { id: string; number: string; status: ProformaStatus }[];
}

export interface OpenOrderList {
  syncedAt: string | null;
  orders: OpenOrder[];
}

export interface OrderNote {
  id: string;
  body: string;
  authorName: string;
  createdAt: string;
  mine: boolean;
}

export function listOpenOrders(): Promise<OpenOrderList> {
  return apiClient.get<OpenOrderList>("/api/v1/open-orders");
}

export function listOrderNotes(orderNumber: string): Promise<OrderNote[]> {
  return apiClient.get<OrderNote[]>(`/api/v1/open-orders/${encodeURIComponent(orderNumber)}/notes`);
}

export function addOrderNote(orderNumber: string, body: string): Promise<OrderNote> {
  return apiClient.post<OrderNote>(`/api/v1/open-orders/${encodeURIComponent(orderNumber)}/notes`, { body });
}

export function deleteOrderNote(id: string): Promise<{ id: string; deleted: boolean }> {
  return apiClient.delete<{ id: string; deleted: boolean }>(`/api/v1/open-orders/notes/${encodeURIComponent(id)}`);
}
